/* eslint-disable sort-keys */
/* eslint-disable @typescript-eslint/member-ordering */

// currently unclear so adding an enum
// TODO make this universal
export enum BuyNowStatus {
    Available = 1,
    Unavailable = 0,
}

// trying to keep the parts separate so they are easer to understand
export type ItemCardModel = {
    // biddingInfo
    bidActivityCount: number;
    bidCount: number;
    bidderBidTimestamp: number;
    bidderHasBid: boolean;
    bidderHasHighBid: boolean;
    bidderMaxBid: number;
    bidderWonItem: boolean;
    imageVersion: number;
    isAvailable: boolean;
    isLocked: boolean;
    isPassed: boolean;
    isReserveMet: boolean;
    isSold: boolean;
    leadingBid: number;
    salePrice: number;
    // Buy Now
    buyNowPrice: number;
    buyNowStatus: BuyNowStatus;
    // Catalog
    catalogId: number;
    catalogStatus: string;
    catalogTitle: string;
    currency: string;
    isCatalogOnly: boolean;
    isLiveAuction: boolean;
    isTimedAuction: boolean;
    lotsListed: number;
    saleStartTs: number;
    // House
    sellerCity: string;
    sellerCountryCode: string;
    sellerId: number;
    sellerLogoId: string;
    sellerName: string;
    sellerStateCode: string;
    // Item
    highBidEstimate: number;
    index: number;
    isDeleted?: boolean;
    isSEOExcluded: boolean;
    itemId: number;
    lotNumber: string;
    lowBidEstimate: number;
    photos: number[];
    promoted?: boolean;
    shortDescription: string;
    startPrice: number;
    title: string;
};

export const emptyDefaultItemCardModel: ItemCardModel = {
    // BiddingInfo
    bidActivityCount: 0,
    bidCount: 0,
    bidderBidTimestamp: 0,
    bidderHasBid: false,
    bidderHasHighBid: false,
    bidderMaxBid: 0,
    bidderWonItem: false,
    imageVersion: 0,
    isAvailable: true,
    isLocked: false,
    isPassed: false,
    isReserveMet: false,
    isSold: false,
    itemId: 0,
    leadingBid: 0,
    salePrice: 0,
    // BuyNow
    buyNowPrice: 0,
    buyNowStatus: BuyNowStatus.Unavailable,
    // Catalog
    catalogId: 0,
    catalogStatus: '',
    catalogTitle: '',
    currency: 'USD',
    isCatalogOnly: false,
    isDeleted: false,
    isLiveAuction: false,
    isTimedAuction: false,
    lotsListed: 0,
    saleStartTs: 0,
    // House
    sellerCity: '',
    sellerCountryCode: '',
    sellerId: 0,
    sellerLogoId: '',
    sellerName: '',
    sellerStateCode: '',
    // Item
    highBidEstimate: 0,
    index: 0,
    isSEOExcluded: false,
    lotNumber: '0',
    lowBidEstimate: 0,
    photos: [],
    promoted: false,
    shortDescription: '',
    startPrice: 0,
    title: '',
};

export type FetchItemsCardModelsResponse = {
    error: boolean;
    message: string;
    payload: {
        items: ItemCardModel[];
        pageCount: number;
        recordCount: number;
        totalRecords: number;
    };
};

/* eslint-enable */
